import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const ActiveFilterRow = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;
  && {
    margin-top: ${layout.measurements.spacing050};
  }
`;

export const TabletUp = styled.div`
  display: none;
  ${media.mediumUp`
    display: block;
  `}
`;

export const MobileOnly = styled.div`
  display: block;
  ${media.mediumUp`
    display: none;
  `}
`;
